// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3nG5Q","right":"styles_right__t8Poq"};